import { API_RESP_INIT } from "src/modules/MYTReportCopy/CalculationForm/modules";
import { ComparisonDashboard } from "./Components/ComparisonDashboard";
import MYTDashboard from "./Components/MYTDashboard";
import { useState } from "react";
import CustomeDialog from "src/shadcn/components/custom/CustomeDialog";
import { CalculatorForm } from "src/modules/MYTReportCopy/CalculationForm/CalculatorForm";
import { CalculatorFormForModel } from "src/modules/MYTReportCopy/CalculationForm/CalculatorFormForModel";
import { MainContextProvider } from "./Components/MainContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "src/shadcn/components/ui/tabs-old";

type Props = {};


const Main = () => {
  const [switcher, setswitcher] = useState<"dashboard" | "data-table">("dashboard")

  return (
    <>
      <div className=" bg-gray-50 space-y-6 max-xl:pb-[100px]">
        {/* Left Side - Scrollable Comparison Dashboard */}
        <div className=" p-4">
          <div className="space-y-2">
            <div className=" mr-9">
              <Tabs value={switcher} onValueChange={(e: any) => setswitcher(e)}>
                <div className="flex justify-between">
                  <div className="text-primary text-xl font-bold px-2">MYT Report</div>
                  <div>
                    <TabsList variant={'black'}>
                      <TabsTrigger variant={'black'} className="text-xs" value="dashboard">Dashboard</TabsTrigger>
                      <TabsTrigger variant={'black'} className="text-xs" value="data-table">Data-Table</TabsTrigger>
                    </TabsList>
                  </div>
                </div>
                <TabsContent value="dashboard"><MYTDashboard /></TabsContent>
                <TabsContent value="data-table"><ComparisonDashboard /></TabsContent>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      <CalculatorFormForModel />
    </>
  );
}

const MytReportPageMain = (props: Props) => {
  return <MainContextProvider>
    <Main />
  </MainContextProvider>

};

export default MytReportPageMain;
